import * as pathFn from 'path';
import {find as findMap} from './map';
import {get as getRole} from './role';
import {parsePathId} from './util';

export interface get {
	/**
	 * 根据功能路径获取Url
	 * @param  {String} pathId 功能路径
	 * @return {String}        实际Url
	 */
	(pathId: string): string,
}

/**
 * 根据功能路径获取Url
 * @param  {String} pathId 功能路径
 * @return {String}        实际Url
 */
export function get(this: { findMap: findMap, getRole: getRole, readonly port: number, readonly protocol: string } | void, pathId: string): string {
	let [path, id, appId] = parsePathId(pathId, this && this.getRole || getRole);
	const item = (this && this.findMap || findMap)(id, appId);
	if (!item) { return ''; }
	const [basePath, domain] = item;
	const port: number = this && this.port || 0;
	const protocol: string = this && this.protocol || '';
	let url = pathFn.join('/', basePath, pathFn.join('/', ...path));
	if (domain) { url = protocol + '//' + domain + (port && ':' + port) + url; }
	return url;
}
interface UrlApi {
	/**
	 * 根据功能路径获取Url
	 * @param  {String} pathId 功能路径
	 * @return {String}        实际Url
	 */
	get: get,
} 
function UrlApi(config: { readonly port: number, readonly protocol: string }, findMap: findMap, getRole: getRole): UrlApi{
	return {
		get: get.bind({
			findMap,
			getRole,
			get port(){return config.port},
			get protocol(){return config.protocol},
		}),
	};
}
export type api = UrlApi;
export default UrlApi;